module.exports = __webpack_public_path__ + "static/media/cancel.03a152a0.png";